import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsultasComponent } from './pages/consultas/consultas.component';
import { DetalleExpedienteComponent } from './pages/detalle-expediente/detalle-expediente.component';
import { ArchivosExpedieteComponent } from './pages/archivos-expediete/archivos-expediete.component';
import { PromociondetalleComponent } from './pages/promociondetalle/promociondetalle.component';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'sucursales',
    loadChildren: () =>
      import('./pages/sucursales/sucursales.module').then(
        (m) => m.SucursalesModule
      ),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./pages/blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: 'articulo/:id',
    loadChildren: () =>
      import('./pages/articulo/articulo.module').then((m) => m.ArticuloModule),
  },
  {
    path: 'sucursalesdetalle/:id',
    loadChildren: () =>
      import('./pages/sucursalesdetalle/sucursalesdetalle.module').then(
        (m) => m.SucursalesdetalleModule
      ),
  },
  {
    path: 'promociones/:categoria',
    loadChildren: () =>
      import('./pages/destinos/destinos.module').then((m) => m.DestinosModule),
  },
  {
    path: 'promociones',
    loadChildren: () =>
      import('./pages/destinos/destinos.module').then((m) => m.DestinosModule),
  },
  {
    path: 'promociondetalle/:id',
    component: PromociondetalleComponent,
  },
  {
    path: 'cliente',
    loadChildren: () =>
      import('./pages/cliente/cliente.module').then((m) => m.ClienteModule),
  },
  {
    path: 'consultas/:caso',
    component: ConsultasComponent,
  },
  {
    path: 'detalle-expediente/:expediente_id',
    component: DetalleExpedienteComponent,
  },
  {
    path: 'archivos-expediente/:expediente_id',
    component: ArchivosExpedieteComponent,
  },
  {
    path: 'hoteles',
    loadChildren:() =>
      import('./pages/hoteles/hoteles.module').then((m) => m.HotelesModule),
  },
  {
    path: 'hoteles-habitaciones',
    loadChildren:() =>
      import('./pages/habitaciones/habitaciones.module').then((m) => m.HabitacionesModule),
  },
  {
    path: 'datos-reserva',
    loadChildren:() =>
      import('./pages/reserva/reserva.module').then((m) => m.ReservaModule),
  },
  {
    path: 'reserva-exitosa',
    loadChildren:() =>
      import('./pages/reserva-exitosa/reserva-exitosa.module').then((m) => m.ReservaExitosaModule),
  },
  {
    path: 'mis-reservas',
    loadChildren:() =>
      import('./pages/reservas/reservas.module').then((m) => m.ReservasModule),
  },

  //PONER TODAS LAS RUTAS ARRIBA
  { path: '**', pathMatch: 'full', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
